import {getFormattedMessage} from 'features/services/utils/language-helper';

export const renderPriceSpan = (minprice: number, maxPrice: number) => {

    const minPriceMillions = minprice / 1000000;
    const maxPriceMillions = maxPrice / 1000000;

    return `${minPriceMillions.toString().replace('.', ',')}-${maxPriceMillions.toString().replace('.', ',')} ${getFormattedMessage('jm.components.ResidenceFilters.millions')}`;
};
